import styled from 'styled-components';
import { device } from '../../../media_queries';

const ResumenMain =  styled.section`
  width: 100%;
  padding: 2% 0 0 2%;
  /* border: 2px dashed black; */
  /* margin: 3% 0 0 2%; */

`;

const RowSectionMain = styled.section`
  width: 100%;
  height: ${props => props.large ? "680px" : props.xlarge ? "1005px" : "335px"};
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${props => props.large ? "column" : props.xlarge ? "column" : "column"};
  justify-content: ${props => props.large ? "flex-start" : "flex-start"};
  align-items: space-around;
  margin: 2% 0;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

const RowSectionMainDynamic = styled.section`
  width: 100%;
  height: ${props => props.large ? "680px" : props.xlarge ? "1005px" : "335px"};
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: ${props => props.unique ? "flex-start" : "space-between"};
  align-items: center;
  /* margin: 2% 0; */
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

export { RowSectionMain, RowSectionMainDynamic, ResumenMain };